/* Put any validator functions in here. They should return
 * a boolean value
 */
import { ISimpleLocation } from 'src/types'
import validator from 'validator'

export function isNotBlank(str: string): boolean {
  return !!(str && str.length > 0)
}

export function isNumberValid(value: string): boolean {
  return !!value && value.length > 0 && !isNaN(Number(value.toString()))
}

export function isValidEmail(value: string): boolean {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}

export function isValidURL(s: string): boolean {
  const res =
    s !== null
      ? s.match(/(http((s)?):\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)
      : null

  return res !== null
}

export function isValidDate(value: string): boolean {
  if (validator.isDate(value)) {
    return true
  } else {
    return false
  }
}

export function isValidDriversLicense(value: string): boolean {
  return value.length < 17
}

export function isValidCoordinates(origin?: ISimpleLocation, destination?: ISimpleLocation) {
  return (
    (origin &&
      (origin.lat !== 0 || origin.lng !== 0) &&
      origin.lat >= -90 &&
      origin.lat <= 90 &&
      origin.lng >= -180 &&
      origin.lng <= 180) ||
    (destination &&
      (destination.lat !== 0 || destination.lng !== 0) &&
      destination.lat >= -90 &&
      destination.lat <= 90 &&
      destination.lng >= -180 &&
      destination.lng <= 180)
  )
}



// WEBPACK FOOTER //
// ./src/utils/validators.ts